<template>
    <div class="consumption-log">
        <el-card shadow="never" class="filter-card">
            <!-- 筛选条件 -->
            <el-form :model="searchForm" inline>
                <el-form-item label="消费类型">
                    <el-select v-model="searchForm.type" placeholder="请选择消费类型" clearable style="width: 160px">
                        <el-option label="全部" value="" />
                        <el-option label="视频混剪" value="video_mix" />
                        <el-option label="AI绘图" value="ai_draw" />
                        <el-option label="AI视频" value="ai_video" />
                        <el-option label="绿书营销" value="lvshu" />
                        <el-option label="AI接口" value="ai_api" />
                    </el-select>
                </el-form-item>

                <el-form-item label="开始日期">
                    <el-date-picker v-model="searchForm.start_date" type="date" placeholder="选择开始日期" format="YYYY-MM-DD"
                        value-format="YYYY-MM-DD" style="width: 160px" />
                </el-form-item>

                <el-form-item label="结束日期">
                    <el-date-picker v-model="searchForm.end_date" type="date" placeholder="选择结束日期" format="YYYY-MM-DD"
                        value-format="YYYY-MM-DD" style="width: 160px" />
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="handleQuery">
                        <el-icon>
                            <Search />
                        </el-icon>查询
                    </el-button>
                    <el-button @click="handleReset">
                        <el-icon>
                            <Refresh />
                        </el-icon>重置
                    </el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card class="mt-4" shadow="never" body-class="table-card-body">
            <div class="table-header">
                <h3 class="table-title">
                    <el-icon>
                        <List />
                    </el-icon>消费记录列表
                </h3>
                <span class="table-tip">共 {{ pagination.total }} 条记录</span>
            </div>

            <el-table :data="tableData" v-loading="loading" border stripe
                :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: 600 }">
                <el-table-column prop="id" label="ID" width="80" align="center" />
                <el-table-column prop="type_name" label="消费类型" width="130" align="center">
                    <template #default="{ row }">
                        <el-tag :type="getTypeTagType(row.type)" effect="light" size="small">
                            {{ row.type_name }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="consumed_points" label="消费点数" width="110" align="center">
                    <template #default="{ row }">
                        <span class="consumed-points">-{{ row.consumed_points }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="unit_cost" label="单价(点)" width="100" align="center">
                    <template #default="{ row }">
                        <span>{{ row.unit_cost }} 点/次</span>
                    </template>
                </el-table-column>
                <el-table-column prop="quantity" label="数量" width="80" align="center" />
                <el-table-column prop="before_points" label="消费前点数" width="120" align="center">
                    <template #default="{ row }">
                        <span>{{ row.before_points }} 点</span>
                    </template>
                </el-table-column>
                <el-table-column prop="after_points" label="消费后点数" width="120" align="center">
                    <template #default="{ row }">
                        <span>{{ row.after_points }} 点</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status_text" label="状态" width="80" align="center">
                    <template #default="{ row }">
                        <el-tag :type="Number(row.status) === 1 ? 'success' : 'danger'" effect="dark" size="small">
                            {{ row.status_text }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="error_message" label="错误信息" min-width="150" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span class="error-message" v-if="row.error_message">{{ row.error_message }}</span>
                        <span class="text-placeholder" v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="notes" label="备注" min-width="200" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span class="notes-text">{{ row.notes || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180" align="center" />
            </el-table>

            <div class="pagination-wrap">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage" :page-sizes="[15, 30, 50, 100]"
                    :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total" background />
            </div>
        </el-card>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { Search, Refresh, List } from '@element-plus/icons-vue'
import axios from 'axios'
import config from '@/config'
import Cookies from 'js-cookie'

const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
const storeId = ref(userInfo.id || 0)
const agentId = ref(userInfo.agent_id || 0)

const loading = ref(false)
const tableData = ref([])

const searchForm = reactive({
    type: '',
    start_date: '',
    end_date: ''
})

const pagination = reactive({
    currentPage: 1,
    pageSize: 15,
    total: 0
})

// 消费类型标签样式
const getTypeTagType = (type) => {
    const map = {
        'video_mix': 'primary',
        'ai_draw': 'success',
        'ai_video': 'warning',
        'lvshu': 'info',
        'ai_api': 'danger'
    }
    return map[type] || 'info'
}



// 获取数据
const fetchData = async () => {
    loading.value = true
    try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/consumption_log_api.php`, {
            params: {
                store_id: storeId.value,
                agent_id: agentId.value,
                type: searchForm.type,
                start_date: searchForm.start_date,
                end_date: searchForm.end_date,
                page: pagination.currentPage,
                pageSize: pagination.pageSize
            }
        })

        if (response.data.code === 200) {
            const list = response.data.data.list || []
            // 转换 status 为数字类型
            list.forEach(item => {
                item.status = Number(item.status)
            })
            tableData.value = list
            pagination.total = response.data.data.total || 0
        } else {
            ElMessage.error(response.data.message || '获取数据失败')
        }
    } catch (error) {
        console.error('获取消费记录失败:', error)
        ElMessage.error('获取数据失败')
    } finally {
        loading.value = false
    }
}
// 查询
const handleQuery = () => {
    pagination.currentPage = 1
    fetchData()
}

// 重置
const handleReset = () => {
    searchForm.type = ''
    searchForm.start_date = ''
    searchForm.end_date = ''
    pagination.currentPage = 1
    fetchData()
}

// 分页
const handleSizeChange = (size) => {
    pagination.pageSize = size
    fetchData()
}

const handleCurrentChange = (page) => {
    pagination.currentPage = page
    fetchData()
}

onMounted(() => {
    fetchData()
})
</script>

<style scoped>
.consumption-log {
    padding: 1px;
}

.mt-4 {
    margin-top: 16px;
}

.filter-card {
    border-radius: 12px;
}

.filter-card :deep(.el-card__body) {
    padding: 20px 24px;
}

.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebeef5;
}

.table-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.table-tip {
    font-size: 13px;
    color: #909399;
}

.pagination-wrap {
    margin-top: 20px;
    text-align: right;
}

.consumed-points {
    color: #f56c6c;
    font-weight: 600;
}

.error-message {
    color: #f56c6c;
    font-size: 12px;
}

.notes-text {
    color: #606266;
    font-size: 12px;
}

.text-placeholder {
    color: #c0c4cc;
}

/* 表格行 hover 效果增强 */
:deep(.el-table__row:hover) {
    background-color: #f5f7fa !important;
}

/* 表格圆角优化 */
:deep(.el-card__body) {
    padding: 20px 24px;
}

/* 分页组件背景 */
:deep(.el-pagination.is-background .el-pager li:not(.is-disabled).is-active) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
</style>